import React, { FC, useEffect, useState } from "react";
import { HandleNext, RentalType } from "../../types";
import { CiWarning } from "react-icons/ci";
import { isSameDay } from "date-fns";
import { useDispatch } from "react-redux";
import { setCancelRental } from "../../redux/slices/rentalSlice";

interface WarningProps extends HandleNext {
  rental: RentalType;
  setShowEndTripModal: (value: boolean) => void;
}
const Warning: FC<WarningProps> = ({
  handleNext,
  rental,
  setShowEndTripModal,
}) => {
  const [tripEndsToday, setTripEndsToday] = useState<boolean>();

  useEffect(() => {
    setTripEndsToday(isSameDay(new Date(rental.rentalEndDatetime), new Date()));
  }, [rental]);

  const dispatch = useDispatch();

  return (
    <div
      className="fixed z-10 inset-0 overflow-y-auto"
      // ref={paymentOptionModal}
    >
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-[90%] mx-auto sm:max-w-[600px]">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mt-3 text-center flex flex-col gap-7">
                <CiWarning
                  className={`h-[100px] w-[100px] rounded-full mx-auto text-white p-2 ${
                    tripEndsToday ? "bg-midGreen" : "bg-red-500"
                  }`}
                />
                <div className="mt-2">
                  <p className="text-sm text-gray-500 text-center">
                    Are you sure you want to end the trip now? Your trip is
                    scheduled to end at{" "}
                    {new Date(
                      rental?.rentalEndDatetime as string
                    ).toDateString()}
                    , {new Date(rental?.rentalEndDatetime as string).getHours()}
                    :
                    {new Date(rental?.rentalEndDatetime as string).getMinutes()}
                  </p>
                  <div className="mt-4 flex gap-3">
                    <button
                      type="button"
                      className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-midGreen text-base font-medium text-white hover:bg-midGreen focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-midGreen sm:text-sm"
                      onClick={() => {
                        setShowEndTripModal(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm"
                      onClick={() => {
                        dispatch(
                          setCancelRental({
                            id: rental.id,
                          })
                        );
                        handleNext();
                      }}
                    >
                      Cancel Trip
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Warning;
